const SpinnerIcon = () => {
  return (
    <svg className='animate-spin-slow' width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="22" width="4" height="12" rx="2" fill="#D9D9D9" />
      <rect x="22" y="36" width="4" height="12" rx="2" fill="#191C20" />
      <rect y="26" width="4" height="12" rx="2" transform="rotate(-90 0 26)" fill="#D9D9D9" />
      <rect x="36" y="26" width="4" height="12" rx="2" transform="rotate(-90 36 26)" fill="#D9D9D9" />
      <rect x="5.61523" y="8.44336" width="4" height="12" rx="2" transform="rotate(-45 5.61523 8.44336)" fill="#D9D9D9" />
      <rect x="31.0713" y="33.8994" width="4" height="12" rx="2" transform="rotate(-45 31.0713 33.8994)" fill="#D9D9D9" />
      <rect x="8.44336" y="42.3848" width="4" height="12" rx="2" transform="rotate(-135 8.44336 42.3848)" fill="#D9D9D9" />
      <rect x="33.8994" y="16.9287" width="4" height="12" rx="2" transform="rotate(-135 33.8994 16.9287)" fill="#D9D9D9" />
    </svg>
  )
};



const  LoadingSpinner = ({ showWhen, showMessage = true }) => {

  if (showWhen) {
    return (
      <>
        {showMessage && <div className="text-2xl font-light mb-[18px]">
          Please wait...
        </div>}
        <div className="font-sans text-sm flex justify-center items-center">
          <SpinnerIcon />
        </div>
      </>
    )
  }
  return null;

}

export default LoadingSpinner;